import { environment } from './../../../environments/environment';

// NOTE: Dictionay of All Calls
export const calls = {
    login: 'auth/token',
    user: 'user',
    'user-access': 'user-access',
    'create-user': 'create-user',
    'validate-account': 'activate',
    dashboard: 'dashboard',
    investors: 'limited-partner',
    funds: 'funds',
    daterange: 'kpi-daterange',
    investorsEmailNotify: 'reset-users-password',
    resetPassword: 'password-reset',
    resetPasswordConfirm: 'password-reset-confirm',
    'activate-user': 'activate',
    dealflow: 'pipeline',
    'deal-info': 'deal-info',
    meeting: 'meeting',
    meetingList: 'meeting-list',
    'meeting-actions': 'meeting-actions',
    'trigger-actions': 'trigger-actions',
    'activity-log': 'activity-log',
    notifications: 'notifications',
    notificationsBulk: 'bulk-notification',
    note: 'note',
    settings: 'app-settings',
    documentation: 'documentation',
    storage: 'storage',
};

export function getCall(call, id = null, params = {}) {
    let url = environment.urlBack + calls[call] + '/';
    if (id != '' && id != null && id != undefined) {
        url += id + '/';
    }
    if (params) {
        url += '?';
        for (const key in params) {
            url += key + '=' + params[key] + '&';
        }
        url = url.slice(0, -1);
    }
    return url;
}

export function createCall(call: string, id?: string, params?: any) {
    let url = `${environment.urlBack}${call}/`;
    if (id) url += `${id}/`;
    if (params) {
        url += '?';
        for (const key in params) {
            url += `${key}=${params[key]}&`;
        }
        url = url.slice(0, -1);
    }
    return url;
}
